export type PhoneModel =
  | 'iPhone 11' | 'iPhone 11 Pro' | 'iPhone 11 Pro Max'
  | 'iPhone 12' | 'iPhone 12 mini' | 'iPhone 12 Pro' | 'iPhone 12 Pro Max'
  | 'iPhone 13' | 'iPhone 13 mini' | 'iPhone 13 Pro' | 'iPhone 13 Pro Max'
  | 'iPhone 14' | 'iPhone 14 Plus' | 'iPhone 14 Pro' | 'iPhone 14 Pro Max'
  | 'iPhone 15' | 'iPhone 15 Plus' | 'iPhone 15 Pro' | 'iPhone 15 Pro Max'
  | 'iPhone 16' | 'iPhone 16 Plus' | 'iPhone 16 Pro' | 'iPhone 16 Pro Max'
  | 'iPhone 17' | 'iPhone 17 Air' | 'iPhone 17 Pro' | 'iPhone 17 Pro Max';

export const OTHER_MODEL = 'android' as const;
export type ModelSelection = PhoneModel | typeof OTHER_MODEL;

export type RepairType = 'ecran' | 'batterie' | 'connecteur' | 'vitre-arriere';

export const OTHER_REPAIR = 'autre' as const;
export type RepairSelection = RepairType | typeof OTHER_REPAIR;

export type PartQuality = 'compatible' | 'origine';

export interface PartQualityInfo {
  id: PartQuality;
  label: string;
}

export const PART_QUALITIES: PartQualityInfo[] = [
  { id: 'compatible', label: 'Compatible' },
  { id: 'origine', label: 'Origine' },
];

export interface RepairTypeInfo {
  id: RepairType;
  label: string;
  icon: 'Smartphone' | 'BatteryCharging' | 'Plug' | 'Layers';
  badge?: string;
}

export const PHONE_MODELS: PhoneModel[] = [
  'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max',
  'iPhone 12', 'iPhone 12 mini', 'iPhone 12 Pro', 'iPhone 12 Pro Max',
  'iPhone 13', 'iPhone 13 mini', 'iPhone 13 Pro', 'iPhone 13 Pro Max',
  'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max',
  'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max',
  'iPhone 16', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max',
  'iPhone 17', 'iPhone 17 Air', 'iPhone 17 Pro', 'iPhone 17 Pro Max',
];

export const REPAIR_TYPES: RepairTypeInfo[] = [
  { id: 'ecran', label: 'Écran', icon: 'Smartphone', badge: 'Le plus demandé' },
  { id: 'batterie', label: 'Batterie', icon: 'BatteryCharging' },
  { id: 'connecteur', label: 'Connecteur de charge', icon: 'Plug' },
  { id: 'vitre-arriere', label: 'Vitre arrière', icon: 'Layers' },
];
